import { UserProfileIcon } from './user-profile-icon';

type AvatarUser = {
  name: string;
  profilePhotoUrl?: string;
};

type Props = {
  users: AvatarUser[];
  totalCount: number;
  maxDisplay?: number;
  size?: string;
};

export function AvatarStack({ users, totalCount, maxDisplay = 6, size = 'size-7' }: Props) {
  const displayed = users.slice(0, maxDisplay);
  const remaining = totalCount - displayed.length;

  if (totalCount === 0) {
    return undefined;
  }

  return (
    <div class="flex items-center">
      {displayed.map((user, i) => (
        <div
          key={i}
          class={`${i > 0 ? '-ml-2' : ''} ring-2 ring-white rounded-full`}
          style={{ zIndex: maxDisplay - i }}
        >
          <UserProfileIcon user={user} size={size} maxWidth={64} />
        </div>
      ))}
      {remaining > 0 && (
        <div
          class={`-ml-2 ${size} inline-flex rounded-full items-center justify-center shrink-0 bg-gray-200 text-gray-600 text-xs font-medium ring-2 ring-white`}
          style={{ zIndex: 0 }}
        >
          +{remaining}
        </div>
      )}
    </div>
  );
}
